import React from 'react';

import { EMonitorTriggerType, IMonitor } from '~/src/dash/api/monitors/monitors_models';
import { ChipDelivering, ChipPending, ChipUntargeted } from '~/src/dash/utils/campaign-status';

export function monitorTriggerTypeToChip(m: EMonitorTriggerType): any {
  switch (m) {
    case EMonitorTriggerType.MonitorTriggerType_ALERT:
      return ChipUntargeted;
    case EMonitorTriggerType.MonitorTriggerType_WARNING:
      return ChipPending;
    case EMonitorTriggerType.MonitorTriggerType_ALERT_RECOVERY:
      return ChipDelivering;
    case EMonitorTriggerType.MonitorTriggerType_WARNING_RECOVERY:
      return ChipDelivering;
    case EMonitorTriggerType.MonitorTriggerType_SHUTDOWN:
      return ChipUntargeted;
  }
  return ChipDelivering;
}

export function getMonitorTriggerType(monitor: IMonitor): EMonitorTriggerType {
  if (monitor.PreviousAlertThresholdBreachedID !== 0) {
    return EMonitorTriggerType.MonitorTriggerType_ALERT;
  } else if (monitor.PreviousWarningThresholdBreachedID !== 0) {
    return EMonitorTriggerType.MonitorTriggerType_WARNING;
  }
  return EMonitorTriggerType.MonitorTriggerType_WARNING_RECOVERY; // good
}

export function renderMonitorStatus(triggerType: EMonitorTriggerType) {
  let statusString: string = 'Good';

  if (triggerType === EMonitorTriggerType.MonitorTriggerType_ALERT) {
    statusString = 'Alert';
  } else if (triggerType === EMonitorTriggerType.MonitorTriggerType_WARNING) {
    statusString = 'Warning';
  } else if (triggerType === EMonitorTriggerType.MonitorTriggerType_SHUTDOWN) {
    statusString = 'Shutdown';
  }
  const Chip = monitorTriggerTypeToChip(triggerType);
  return <Chip label={statusString} />;
}
